import { render, staticRenderFns } from "./SirketList.vue?vue&type=template&id=0a859714&scoped=true&"
import script from "./SirketList.vue?vue&type=script&lang=js&"
export * from "./SirketList.vue?vue&type=script&lang=js&"
import style0 from "./SirketList.vue?vue&type=style&index=0&id=0a859714&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a859714",
  null
  
)

export default component.exports